module.exports = __webpack_public_path__ + "static/media/start.974a61b6.mp3";